class Locations {
    constructor() {
        this.contactList();
        //this.goBackToMapView();
        //this.resizeEvent();
    }

    goBackToMapView(){
        var goBackLink = document.getElementById("goBackLink");

        // Add a click event listener to the link
        goBackLink.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent the default behavior of navigating to "#"
            window.history.back(); // Go to the previous page
        });
    }

    contactList() {
        const btnContact = document.querySelector('#btnContact');
        btnContact.addEventListener('click', function(e){
            e.preventDefault();
            const contactBlock = document.querySelector('#contacts');
            contactBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }
    resizeEvent(){
        // Add a resize event listener
        window.addEventListener('resize', function() {
            // Get the current window width
            var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        
            // Check if the window width is less than 1024 pixels
            if (windowWidth > 1024) {
                // Redirect to the desired URL
                window.location.href = '/map-test/';
                //window.location.href = '/where-we-work-new/'; // Replace with your desired URL
            }
        });
  
    }

}

export default Locations;
new Locations();
